<template>
  <div class="page-default page-cases bg-dashboard-dark-2">
    <div class="row m-0 page-section">
      <div
        class="col col-md-4 col-lg-3 section-left"
        :class="{ show: showSidebar }"
      >
        <div class="case-container bg-dashboard-dark-1">
          <div class="case-header text-light">
            <div
              class="d-flex justify-content-center align-items-center"
              :class="{ invisible: cases.length < 1 }"
            >
              Page
              <input
                ref="pageInput"
                class="
                  form-control form-control-default form-control-sm
                  text-center
                  mx-1
                  bg-dark-input
                "
                style="width: 40px"
                v-model="inputPage"
                type="number"
                @keydown.enter="$event.target.blur()"
                @blur="changePage(inputPage)"
              />
              of {{ totalPage }}
              <div class="btn-group ml-2">
                <button
                  class="btn btn-dark btn-sm border border-outline-dark-all"
                  title="Previous page"
                  :disabled="currentPage <= 1"
                  @click="changePage(currentPage - 1)"
                >
                  ‹
                </button>
                <button
                  class="btn btn-dark btn-sm border border-outline-dark-all"
                  title="Next page"
                  :disabled="currentPage >= totalPage"
                  @click="changePage(currentPage + 1)"
                >
                  ›
                </button>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <button
                class="btn btn-sm btn-primary mr-2"
                type="button"
                @click="downloadClicked"
              >
                <font-awesome-icon :icon="['fas', 'file-download']" />
              </button>
              <div class="dropdown">
                <button
                  class="btn btn-sm btn-primary no-focus no-pseudo"
                  type="button"
                  id="dropdownActionButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <font-awesome-icon :icon="['fas', 'plus']" />
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right p-0"
                  aria-labelledby="dropdownMenuButton"
                  style="max-height: 200px; overflow-y: auto"
                >
                  <button
                    class="
                      dropdown-item
                      py-2
                      px-3
                      btn-secondary
                      border-outline-dark-bottom
                      fs-8
                      text-white
                    "
                    @click="editCase('add')"
                  >
                    Create Sebut Harga
                  </button>
                </div>
              </div>
              <div
                class="case-header-icon clickable ml-3 d-block d-md-none"
                @click="toggleSidebar()"
              >
                <font-awesome-icon :icon="['fas', 'times']" />
              </div>
            </div>
          </div>
          <div class="case-filter">
            <!-- <div
              class="row mx-0"
              :style="{
                transition: 'all 0.3s',
                height: hideFilter ? '0' : '47px',
                overflow: hideFilter ? 'hidden' : 'unset',
              }"
            >
              <div
                class="
                  col-6
                  px-0
                  border-right border-bottom border-outline-dark
                "
              >
                <div class="dropdown">
                  <button
                    class="
                      btn btn-sm btn-block
                      no-focus
                      position-relative
                      rounded-0
                      py-0
                      px-2
                      d-flex
                      justify-content-between
                      align-items-center
                      overflow-hidden
                    "
                    type="button"
                    id="dropdownDistrictButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    @click="
                      dropdownActive == 'district'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'district')
                    "
                    @blur="dropdownActive = ''"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        w-100
                        py-2
                      "
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          class="text-light"
                          :icon="['fas', 'filter']"
                          :class="{ 'text-primary': currentDistrict }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-dark"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="currentDistrict"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-light">District</p>
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <p class="mb-0 text-nowrap text-truncate text-white">
                            {{ currentDistrict ? currentDistrict.name : "All" }}
                          </p>
                          <font-awesome-icon
                            v-if="dropdownActive == 'district'"
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-up']"
                          />
                          <font-awesome-icon
                            v-else
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-down']"
                          />
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0 border-0"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="
                        dropdown-item
                        font-weight-medium
                        d-flex
                        justify-content-between
                        align-items-center
                        py-2
                        px-3
                        btn-secondary
                        border-outline-dark-bottom
                        fs-8
                      "
                      :class="
                        currentDistrict == null ? 'text-white' : 'text-light'
                      "
                      @click="currentDistrict = null"
                    >
                      All districts
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="currentDistrict == null"
                      />
                    </button>
                    <button
                      v-for="district in userRole == 'Supervisor'
                        ? userDistricts
                        : allDistricts"
                      :key="district._id"
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                        py-2
                        px-3
                        btn-secondary
                        border-outline-dark-bottom
                        fs-8
                      "
                      :class="
                        currentDistrict && currentDistrict._id == district._id
                          ? 'text-white'
                          : 'text-light'
                      "
                      @click="currentDistrict = district"
                    >
                      {{ district.name }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="
                          currentDistrict && currentDistrict._id == district._id
                        "
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0 border-bottom border-outline-dark">
                <button
                  class="
                    btn btn-sm
                    text-left
                    d-flex
                    rounded-0
                    justify-content-start
                    align-items-center
                    position-relative
                    p-2
                    w-100
                  "
                  type="button"
                  @click="showDateSelector = true"
                >
                  <div class="mr-2">
                    <font-awesome-icon
                      class="text-light"
                      :icon="['far', 'calendar-alt']"
                      :class="{ 'text-primary': dateFilter }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-dark"
                      style="font-size: 0.85em;
                        position: absolute;
                        top: 1.55em;
                        right: 0.45em;
                      "
                      v-if="dateFilter"
                    />
                  </div>
                  <div class="w-100 overflow-hidden" style="line-height: 1.3">
                    <p class="small mb-0 text-light">Date</p>
                    <p class="mb-0 text-nowrap text-truncate text-white">
                      {{ dateFilter ? displayDateFilter : "All" }}
                    </p>
                  </div>
                </button>
              </div>
              
            
            </div> -->
            
            <!-- <button
              class="btn btn-sm btn-block rounded-0 bg-dark-ds text-secondary"
              @click="hideFilter = !hideFilter"
            >
              <font-awesome-icon
                :icon="['fas', 'angle-up']"
                v-if="!hideFilter"
              />
              <font-awesome-icon :icon="['fas', 'angle-down']" v-else />
            </button> -->
            <!-- <div class="input-group mb-0 border-outline-dark-all shadow-sm">
              <input
                type="text"
                class="form-control border-0 text-white text-placeholder"
                placeholder="Search by case number"
                v-model="search"
                id="seachCaseNo"
                autocomplete="off"
                @keydown.enter="searchByCaseNumber(search)"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-dark ps-0"
                  v-if="search.length > 0"
                  @click="searchByCaseNumber('')"
                >
                  <span>&times;</span>
                </button>
                <button
                  class="
                    btn btn-dark
                    rounded-0
                    border-left border-outline-dark border-left-2
                    px-3
                  "
                  @click="searchByCaseNumber(search)"
                >
                  <font-awesome-icon :icon="['fas', 'search']" />
                </button>
              </div>
            </div> -->
          </div>
          <div
            class="case-body has-filter rounded-0 shadow-none"
            style="{
              height: 'calc(100% - 43px - 48px)',
            }"
          >
          <div
              class="row mx-0 border-dark border-bottom"
              :style="{
                transition: 'all 0.3s',
                height: hideFilter ? '0' : '47px',
                overflow: hideFilter ? 'hidden' : 'unset',
              }"
            >
              <div
                class="
                  col-6
                  px-0
                  border-right border-bottom border-outline-dark
                "
              >
                <div class="dropdown">
                  <button
                    class="
                      btn btn-sm btn-block
                      no-focus
                      position-relative
                      rounded-0
                      py-0
                      px-2
                      d-flex
                      justify-content-between
                      align-items-center
                      overflow-hidden
                    "
                    type="button"
                    id="dropdownDistrictButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    @click="
                      dropdownActive == 'district'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'district')
                    "
                    @blur="dropdownActive = ''"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        w-100
                        py-2
                      "
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          class="text-light"
                          :icon="['fas', 'filter']"
                          :class="{ 'text-primary': currentDistrict }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-dark"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="currentDistrict"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-light">District</p>
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <p class="mb-0 text-nowrap text-truncate text-white">
                            {{ currentDistrict ? currentDistrict.name : "All" }}
                          </p>
                          <font-awesome-icon
                            v-if="dropdownActive == 'district'"
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-up']"
                          />
                          <font-awesome-icon
                            v-else
                            class="text-white mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-down']"
                          />
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0 border-0"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="
                        dropdown-item
                        font-weight-medium
                        d-flex
                        justify-content-between
                        align-items-center
                        py-2
                        px-3
                        btn-secondary
                        border-outline-dark-bottom
                        fs-8
                      "
                      :class="
                        currentDistrict == null ? 'text-white' : 'text-light'
                      "
                      @click="currentDistrict = null"
                    >
                      All districts
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="currentDistrict == null"
                      />
                    </button>
                    <button
                      v-for="district in userRole == 'Supervisor'
                        ? userDistricts
                        : allDistricts"
                      :key="district._id"
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                        py-2
                        px-3
                        btn-secondary
                        border-outline-dark-bottom
                        fs-8
                      "
                      :class="
                        currentDistrict && currentDistrict._id == district._id
                          ? 'text-white'
                          : 'text-light'
                      "
                      @click="currentDistrict = district"
                    >
                      {{ district.name }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="
                          currentDistrict && currentDistrict._id == district._id
                        "
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0 border-bottom border-outline-dark">
                <button
                  class="
                    btn btn-sm
                    text-left
                    d-flex
                    rounded-0
                    justify-content-start
                    align-items-center
                    position-relative
                    p-2
                    w-100
                  "
                  type="button"
                  @click="showDateSelector = true"
                >
                  <div class="mr-2">
                    <font-awesome-icon
                      class="text-light"
                      :icon="['far', 'calendar-alt']"
                      :class="{ 'text-primary': dateFilter }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-dark"
                      style="font-size: 0.85em;
                        position: absolute;
                        top: 1.55em;
                        right: 0.45em;
                      "
                      v-if="dateFilter"
                    />
                  </div>
                  <div class="w-100 overflow-hidden" style="line-height: 1.3">
                    <p class="small mb-0 text-light">Date</p>
                    <p class="mb-0 text-nowrap text-truncate text-white">
                      {{ dateFilter ? displayDateFilter : "All" }}
                    </p>
                  </div>
                </button>
              </div>
              
            
            </div>
            <div ref="caseList" class="projects-list-container h-100">
              <div
                class="
                  case-list
                  position-relative
                  hover-parent
                  pr-0
                  py-0
                  border-outline-dark-bottom
                "
                v-for="cse in cases"
                :key="`${cse._id}-${cse.index}`"
                :id="cse._id"
                :class="{ active: currentCase == cse }"
                @click="goTo(cse._id)"
              >
                <div class="d-flex justify-content-between">
                  <div class="d-inline-block text-truncate py-3 pr-3">
                    <p class="font-weight-bold mb-0 text-white">
                      [#{{ cse.index }}]
                      {{ helper.formatDate(cse.timestamp) }}
                      <span
                        class="
                          badge badge-warning
                          text-dark
                          badge-pill
                          mb-2
                          ml-2
                        "
                        v-if="cse.isNoe"
                      >
                        NOE
                      </span>
                      <span
                        class="badge badge-info badge-pill mb-2 ml-2"
                        v-else-if="cse.nod_case"
                      >
                        NOD
                      </span>
                      <span
                        class="badge badge-success badge-pill mb-2 ml-2"
                        v-else-if="cse.status == 'solved'"
                      >
                        Closed
                      </span>
                      <span
                        class="badge badge-danger badge-pill mb-2 ml-2"
                        v-else-if="cse.status == 'received'"
                      >
                        Open
                      </span>
                      <span
                        class="badge badge-warning badge-pill mb-2 ml-2"
                        v-else-if="cse.status == 'pending'"
                      >
                        Pending
                      </span>
                      <span class="badge badge-secondary badge-pill mb-2 ml-2">
                        {{ cse.reportType }}
                      </span>
                    </p>
                    <p
                      class="small mb-0 text-nowrap text-truncate"
                      :class="currentCase == cse ? 'text-white' : 'text-light'"
                    >
                      <strong>Case Number</strong> {{ cse.caseNumber }}
                    </p>
                    <p
                      class="small mb-0 text-nowrap text-truncate"
                      v-if="cse.road"
                      :class="currentCase == cse ? 'text-white' : 'text-light'"
                    >
                      {{
                        helper.getRoadInfo({
                          name: cse.road.name,
                          district:
                            getDistrictName(cse.road.daerah) ||
                            cse.road.district,
                        })
                      }}
                    </p>
                    <p
                      class="small mb-0 text-nowrap text-truncate"
                      v-if="cse.lat && cse.lng"
                      :class="currentCase == cse ? 'text-white' : 'text-light'"
                    >
                      [{{ helper.formatCoordinate([cse.lat, cse.lng]) }}]
                    </p>
                    <p
                      class="small mb-0 text-nowrap font-weight-bold"
                      v-if="cse.user"
                      :class="currentCase == cse ? 'text-white' : 'text-light'"
                    >
                      Created By {{ cse.user.name }}
                    </p>
                    <button
                      class="btn btn-sm btn-danger position-absolute hover-item"
                      style="top: 1rem; right: 1rem"
                      @click.stop="deleteCase(cse)"
                    >
                      <font-awesome-icon :icon="['fas', 'trash-alt']" />
                    </button>
                    <button
                      class="
                        btn btn-sm btn-info
                        position-absolute
                        hover-item
                        line-height-1
                      "
                      style="top: 3.2rem; right: 1rem"
                      @click.stop="addToNOD(cse)"
                      v-if="!cse.nod_case"
                    >
                      <font-awesome-icon
                        class="small"
                        :icon="['fas', 'plus']"
                      />
                      <p class="mb-0" style="font-size: 0.3rem">NOD</p>
                    </button>
                    <button
                      class="
                        btn btn-sm btn-success
                        position-absolute
                        hover-item
                        line-height-1
                      "
                      style="top: 3.2rem; right: 1rem"
                      @click.stop="openCMS(cse.nod_case)"
                      v-if="cse.nod_case"
                    >
                      <font-awesome-icon
                        class="small"
                        :icon="['fa', 'external-link-alt']"
                      />
                      <p class="mb-0" style="font-size: 0.3rem">NOD</p>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="p-4 d-flex justify-content-center align-items-center"
                v-if="cases.length > 0"
              >
                <p class="mb-0 font-italic text-muted">
                  End of
                  {{
                    currentPage == totalPage ? "list" : `page ${currentPage}`
                  }}
                </p>
              </div>
              <div
                class="p-4 d-flex justify-content-center align-items-center"
                v-else
              >
                <p class="mb-0 font-italic text-muted">No case found</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col section-right text-truncate d-flex px-0 px-md-3">
        <div class="case-container bg-dashboard-dark-1 w-100">
          <div class="section-header bg-dashboard-dark-1 border-bottom">
            <button
              class="
                btn btn-outline-primary
                shadow-sm
                mr-3
                section-left-toggler
              "
              @click="toggleSidebar()"
            >
              <font-awesome-icon :icon="['fas', 'angle-right']" />
            </button>
            <div
              v-if="currentCase"
              class="
                w-100
                d-flex
                flex-column flex-sm-row
                justify-content-between
                align-items-start align-items-sm-center
              "
            >
              <div class="d-flex align-items-center">
                <div
                  class="p-1 align-self-stretch rounded mr-2 bg-info"
                  v-if="currentCase.nod_case"
                ></div>
                <div
                  class="p-1 align-self-stretch rounded mr-2 bg-warning"
                  v-else-if="currentCase.isNoe"
                ></div>
                <div
                  class="p-1 align-self-stretch rounded mr-2 bg-success"
                  v-else-if="currentCase.status == 'solved'"
                ></div>
                <div
                  class="p-1 align-self-stretch rounded mr-2 bg-danger"
                  v-else-if="currentCase.status == 'received'"
                ></div>
                <div
                  class="p-1 align-self-stretch rounded mr-2 bg-warning"
                  v-else-if="currentCase.status == 'pending'"
                ></div>
                <div>
                  <div
                    class="
                      text-uppercase text-nowrap
                      d-flex
                      align-items-center
                      text-white
                    "
                  >
                    [#{{ currentCase.index }}]
                    {{ helper.formatDate(currentCase.timestamp) }}
                    <button
                      class="btn btn-edit p-0 btn-sm"
                      @click="editCase(currentCase)"
                    >
                      <font-awesome-icon
                        :icon="['far', 'edit']"
                        class="ml-2 text-primary"
                      />
                    </button>
                  </div>
                  <p
                    class="
                      text-light
                      mb-0
                      small
                      d-none d-sm-block
                      text-nowrap text-truncate
                    "
                  >
                    <template v-if="currentCase.road">
                      {{
                        helper.getRoadInfo({
                          name: currentCase.road.name,
                          district:
                            getDistrictName(currentCase.road.daerah) ||
                            currentCase.road.district,
                        })
                      }}
                    </template>
                  </p>
                </div>
              </div>
              <div
                class="
                  pl-0 pl-sm-2
                  d-flex
                  flex-column
                  align-items-sm-end
                  justify-content-center
                  align-items-start
                "
              >
                <small class="text-light text-nowrap text-truncate">
                  <strong>Case Number</strong> {{ currentCase.caseNumber }}
                </small>
                <a
                  v-if="!isNaN(currentCase.lat) && !isNaN(currentCase.lng)"
                  class="small"
                  :href="`https://www.google.com/maps/place/${currentCase.lat}, ${currentCase.lng}`"
                  target="_blank"
                >
                  <font-awesome-icon
                    :icon="['fas', 'map-marker-alt']"
                    class="mr-1"
                  />
                  {{
                    helper.formatCoordinate([currentCase.lat, currentCase.lng])
                  }}
                </a>
              </div>
            </div>
            <p
              v-else
              class="
                font-weight-normal
                small
                mb-0
                font-italic
                flex-grow-1
                text-center text-muted
              "
            >
              No case selected
            </p>
          </div>
          <div
            ref="reportBody"
            class="report-body w-100 bg-dashboard-dark-1"
            v-if="currentCase"
          >
            <div
              class="case-map bg-dashboard-dark-1"
              :style="
                currentCase.lat !== null && currentCase.lng !== null
                  ? ''
                  : 'height: 0px'
              "
            >
              <div id="map"></div>
              <Pin
                :key="casePin._id"
                :map="map"
                :caseItem="casePin"
                v-if="casePin"
              />
            </div>
            <div class="px-3 pb-3 border-outline-dark-bottom">
              <span
                class="badge badge-warning text-dark badge-pill mb-2 mr-2"
                v-if="currentCase.isNoe"
              >
                NOE
              </span>
              <span
                class="badge badge-info badge-pill mb-2 mr-2"
                v-else-if="currentCase.nod_case"
              >
                NOD
              </span>
              <span
                class="badge badge-warning text-dark badge-pill mb-2"
                v-if="currentCase.status == 'pending'"
              >
                PENDING
              </span>
              <span
                class="badge badge-success text-dark badge-pill mb-2"
                v-if="currentCase.status == 'solved'"
              >
                CLOSED
              </span>
              <span
                class="badge badge-danger text-dark badge-pill mb-2"
                v-if="currentCase.status == 'received'"
              >
                OPEN
              </span>
              <p class="mb-0 small text-light">{{ currentCase.caption }}</p>
            </div>
            <div class="row">
              <div class="col-12 col-lg-6 border-right border-outline-dark">
                <div class="case-before p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-secondary badge-pill
                      px-2
                    "
                  >
                    Before
                  </p>
                  <div class="media-grid no-pseudo w-100">
                    <div v-for="media in currentCase.media" :key="media._id">
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(media)"
                          @click="currentMedia = media"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage('before', media._id)"
                        v-if="currentCase.media.length > 1"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          rounded
                          bg-grey-light
                        "
                        @click="addImage('before')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x text-muted"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline text-muted">Before</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="case-during p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-info badge-pill
                      px-2
                    "
                  >
                    During
                  </p>
                  <div class="media-grid no-pseudo">
                    <div
                      :key="file._id"
                      v-for="file in currentCase.media_during"
                    >
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(file)"
                          @click="currentMedia = file"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage('during', file._id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          rounded
                          bg-grey-light
                        "
                        @click="addImage('during')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x text-muted"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline text-muted">During</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="case-after p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-primary badge-pill
                      px-2
                    "
                  >
                    After
                  </p>
                  <div
                    class="
                      small
                      rounded
                      bg-dark-input
                      border border-outline-dark
                      p-2
                      mb-2
                    "
                  >
                    <p
                      class="
                        text-light
                        font-weight-medium
                        mb-1
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      Repair Notes
                      <button
                        class="btn btn-sm text-primary p-0"
                        @click="isEditingAfterCaption = true"
                      >
                        <font-awesome-icon :icon="['far', 'edit']" />
                      </button>
                    </p>
                    <template v-if="isEditingAfterCaption">
                      <textarea
                        rows="5"
                        class="
                          form-control form-control-default form-control-sm
                          bg-dark-input
                          border-0
                          text-white
                        "
                        style="resize: none"
                        v-model="afterCaptionModel"
                      ></textarea>
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                          mt-3
                        "
                      >
                        <button
                          class="btn btn-sm btn-outline-light"
                          @click="cancelEditAfterCaption()"
                        >
                          Cancel
                        </button>
                        <button
                          class="btn btn-sm btn-primary"
                          @click="saveAfterCaption()"
                        >
                          Save
                        </button>
                      </div>
                    </template>
                    <p class="mb-0 text-muted" v-else>
                      <span v-if="currentCase.afterCaption">
                        {{ currentCase.afterCaption }}
                      </span>
                      <span v-else class="font-italic">No note</span>
                    </p>
                  </div>
                  <div
                    class="
                      small
                      rounded
                      bg-dark-input
                      border border-outline-dark
                      p-2
                      mb-2
                    "
                  >
                    <label
                      for="solveDate"
                      class="text-light font-weight-medium mb-1"
                    >
                      Closed date
                    </label>
                    <div
                      class="text-muted font-italic"
                      v-if="
                        currentCase.media_after.length < 1 ||
                        currentCase.media_during.length < 1
                      "
                    >
                      Upload
                      <span
                        class="
                          text-monospace text-white
                          font-weight-medium
                          ml-1
                        "
                      >
                        During
                      </span>
                      &amp;
                      <span
                        class="
                          text-monospace text-white
                          font-weight-medium
                          ml-1
                        "
                      >
                        After
                      </span>
                      picture to set closed date
                    </div>
                    <div
                      class="d-flex justify-content-between align-items-center"
                      v-else
                    >
                      <p
                        class="mb-0 text-white clickable"
                        @click="showCloseDateSelector = true"
                      >
                        {{
                          currentCase.solveDate
                            ? helper.formatDate(currentCase.solveDate)
                            : "Click here to set closed date"
                        }}
                      </p>
                      <button
                        class="btn btn-sm btn-link p-0"
                        v-if="currentCase && currentCase.solveDate"
                        @click="reopenCase(currentCase._id)"
                      >
                        Re-open
                      </button>
                    </div>
                  </div>
                  <div class="media-grid no-pseudo">
                    <div
                      :key="file._id"
                      v-for="file in currentCase.media_after"
                    >
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(file)"
                          @click="currentMedia = file"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage('after', file._id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          rounded
                          bg-grey-light
                        "
                        @click="addImage('after')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x text-muted"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline text-muted">After</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="
                  col-12 col-lg-6
                  border-0
                  bg-dashboard-dark-1
                  border-outline-dark
                "
              >
              <div class="case-before p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-secondary badge-pill
                      px-2
                    "
                  >
                    Bill of Quantity
                  </p>
                  <div class="media-grid no-pseudo w-100">
                    <div v-if="currentCase.districtBQ">
                      <div class="img-container d-flex justify-content-center p-2">
                        <img
                          src="../assets/pdf.png"
                          class="h-100"
                          @click="openFile(currentCase.districtBQ.url)"
                        />
                          <!-- @click="currentMedia = media" -->

                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteSHFile('districtBQ', currentCase.districtBQ.id)"
                        v-if="currentCase.districtBQ"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div  v-if="!currentCase.districtBQ">
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          rounded
                          bg-grey-light
                        "
                        @click="addSHFile('districtBQ')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'file-upload']"
                            class="fa-stack-1x text-muted"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline text-muted">BQ</pre>
                          file (pdf)
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="case-before p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-secondary badge-pill
                      px-2
                    "
                  >
                    Arahan Kerja
                  </p>
                  <div class="media-grid no-pseudo w-100">
                    <div v-if="currentCase.districtAK">
                      <div class="img-container d-flex justify-content-center p-2">
                        <img
                          src="../assets/pdf.png"
                          class="h-100"
                          @click="openFile(currentCase.districtAK.url)"
                        />
                          <!-- @click="currentMedia = media" -->

                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteSHFile('districtAK', currentCase.districtAK.id)"
                        v-if="currentCase.districtAK"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div v-if="!currentCase.districtAK">
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          rounded
                          bg-grey-light
                        "
                        @click="addSHFile('districtAK')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'file-upload']"
                            class="fa-stack-1x text-muted"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline text-muted">AK</pre>
                          file (pdf)
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="case-verification py-3 pl-3 pl-lg-0 pr-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-success badge-pill
                      px-2
                    "
                  >
                    Verifications
                  </p>
                  <div
                    class="card border mt-1 border-outline-dark mb-4"
                    v-for="verification in sortedVerifications"
                    :key="verification._id"
                  >
                    <div class="card-body bg-dashboard-dark-1 bg-dark-input">
                      <p class="small text-muted font-weight-medium mb-2">
                        <font-awesome-icon
                          :icon="['far', 'calendar-alt']"
                          class="mr-2"
                        />
                        {{ helper.formatDate(verification.datetime, true) }}
                      </p>
                      <p class="small text-muted font-weight-medium">
                        <font-awesome-icon
                          :icon="['far', 'sticky-note']"
                          class="mr-2"
                        />
                        {{ verification.remarks }}
                      </p>
                      <div class="media-grid no-pseudo">
                        <div v-for="file in verification.media" :key="file._id">
                          <div class="img-container">
                            <img
                              :src="helper.formatMediaUrl(file)"
                              @click="currentMedia = file"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="sortedVerifications.length == 0"
                    class="card border-0 clickable no-bg"
                    @click="addingVerification = true"
                  >
                    <div
                      class="
                        card-body
                        d-flex
                        flex-column
                        justify-content-center
                        align-items-center
                        bg-grey-light
                      "
                    >
                      <font-awesome-icon
                        class="text-muted"
                        :icon="['fas', 'plus']"
                        style="font-size: 25px"
                      />
                      <small class="text-muted mt-1">
                        Add new verification
                      </small>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <spinner v-if="isProcessing" />
    <add-to-nod-modal
      :show="addToNodData.show"
      :currentCase="addToNodData.case"
      :nodCases="nodCases"
      @close="closeAddToNODModal"
      @createNodCms="createNodCms"
    />
    <media-preview
      v-if="currentMedia"
      :url="helper.formatMediaUrl(currentMedia)"
      @close="currentMedia = null"
    />
    <date-selector
      v-if="showDateSelector"
      :dateRange="dateFilter"
      :isRange="true"
      @close="dateSelected"
    />
    <date-time-selector
      v-if="showCloseDateSelector"
      :isRange="false"
      :date="
        currentCase && currentCase.solveDate
          ? new Date(currentCase.solveDate * 1000)
          : new Date()
      "
      @close="closeDateSelected"
    />
    <edit-case-modal
      :show="editingCase"
      :currentCase="currentCase"
      :districts="userRole == 'Supervisor' ? userDistricts : allDistricts"
      :contractors="contractors"
      :isTender="true"
      :roads="
        allDistricts
          ? allDistricts.map((district) => district.roads).flat()
          : []
      "
      @close="closeEditCase"
    />
    <add-case-verification-modal
      :show="addingVerification"
      :currentCase="currentCase"
      @getCases="reload"
      @close="closeAddVerification"
    />
  </div>
</template>

<script>
import "mapbox-gl";
import API from "@/api";
import Moment from "moment";
import Helper from "@/helper";
import Swal from "sweetalert2";
import Pin from "@/components/Pin";
import Spinner from "@/components/Spinner";
import DateSelector from "@/components/DateSelector";
import DateTimeSelector from "@/components/DateTimeSelector";
import EditCaseModal from "@/modals/EditCase.vue";
import AddCaseVerificationModal from "@/modals/AddCaseVerification.vue";
import MediaPreview from "@/components/MediaPreview";
import AddToNodModal from "@/components/AddToNOD";
import * as XLSX from "xlsx/xlsx.mjs";

let initialArrayWorkLayer = [
  {
    id: "unregistered",
    layer: "",
    name: "Unregistered",
    show: true,
  },
  {
    id: "KKE",
    layer: "",
    name: "KKE",
    show: true,
  },
  {
    id: "R01",
    layer: "",
    name: "R01",
    show: true,
  },
  {
    id: "R02",
    layer: "",
    name: "R02",
    show: true,
  },
  {
    id: "R03",
    layer: "",
    name: "R03",
    show: true,
  },
  {
    id: "R04",
    layer: "",
    name: "R04",
    show: true,
  },
  {
    id: "R05",
    layer: "",
    name: "R05",
    show: true,
  },
  {
    id: "R06",
    layer: "",
    name: "R06",
    show: true,
  },
  {
    id: "R07",
    layer: "",
    name: "R07",
    show: true,
  },
  {
    id: "R08",
    layer: "",
    name: "R08",
    show: true,
  },
  {
    id: "R11",
    layer: "",
    name: "R11",
    show: true,
  },
];

const lastWeek = Moment()
  .subtract(1, "week")
  .startOf("day")
  .format("YYYY-MM-DD");
const today = Moment().endOf("day").format("YYYY-MM-DD");

export default {
  name: "cases",
  components: {
    Pin,
    Spinner,
    MediaPreview,
    DateSelector,
    DateTimeSelector,
    EditCaseModal,
    AddCaseVerificationModal,
    AddToNodModal,
  },
  data() {
    return {
      addToNodData: {
        show: false,
        case: null,
      },
      showAllWorkLayer: true,
      map: null,
      casePin: null,
      helper: Helper,
      isProcessing: false,
      isEditingAfterCaption: false,
      afterCaptionModel: null,
      showSidebar: false,
      cases: [],
      allDistricts: [],
      currentCase: null,
      casesCount: 0,
      currentPage: 1,
      pageLimit: 100,
      totalPage: 1,
      inputPage: 1,
      currentMedia: null,
      editingCase: null,
      userDistricts: [],
      userRole: null,
      currentDistrict: null,
      dateFilter: { start: lastWeek, end: today },
      showDateSelector: false,
      verifiedFilter: false,
      workScopeFilter: initialArrayWorkLayer,
      contractorFilter: null,
      timeFilter: null,
      workScopes: initialArrayWorkLayer,
      addingVerification: false,
      search: "",
      contractors: [],
      countLoading: true,
      hideFilter: false,
      dropdownActive: "",
      showCloseDateSelector: false,
      filterByStatus: null,
      listOfCaseCount: [
        {
          label: "Open Case",
          color: "bg-danger",
          value: 0,
        },
        {
          label: "Closed Case",
          color: "bg-success",
          value: 0,
        },
        {
          label: "Pending",
          color: "bg-warning",
          value: 0,
        },
      ],
      nodCases: [],
    };
  },
  watch: {
    currentDistrict: {
      async handler() {
        await this.getSummaryData();
      },
      immediate: false,
    },
    verifiedFilter: {
      async handler() {
        await this.getSummaryData();
      },
      immediate: false,
    },
    contractorFilter: {
      async handler() {
        await this.getSummaryData();
      },
      immediate: false,
    },
    timeFilter: {
      async handler() {
        console.log(this.timeFilter)
        await this.getSummaryData();
      },
      immediate: false,
    },
    search: {
      handler() {
        if (this.search.length === 0) {
          this.search = "";
          this.changePage(1, true);
        }
      },
      immediate: false,
    },
  },
  computed: {
    showContractor() {
      let _user = localStorage.getItem("user");

      if (_user) {
        let data = JSON.parse(_user).role.name;
        if (data === "JKR" || data === "Super Admin") return true;
        else return false;
      }
      return;
    },
    sortedVerifications() {
      let verifications = this.currentCase.verifications
        ? JSON.parse(JSON.stringify(this.currentCase.verifications))
        : [];

      return verifications.sort((a, b) => {
        let aDatetime = Moment(a.datetime).unix();
        let bDatetime = Moment(b.datetime).unix();

        return aDatetime - bDatetime;
      });
    },
    displayDateFilter() {
      if (this.dateFilter) {
        if (this.dateFilter.start == this.dateFilter.end) {
          return Moment(this.dateFilter.start).format("D MMM YYYY");
        } else if (
          Moment(this.dateFilter.start).format("MM-YYYY") ==
          Moment(this.dateFilter.end).format("MM-YYYY")
        ) {
          return `${Moment(this.dateFilter.start).format("D")} - ${Moment(
            this.dateFilter.end
          ).format("D MMM YYYY")}`;
        } else if (
          Moment(this.dateFilter.start).format("YYYY") ==
          Moment(this.dateFilter.end).format("YYYY")
        ) {
          return `${Moment(this.dateFilter.start).format("D MMM")} - ${Moment(
            this.dateFilter.end
          ).format("D MMM YYYY")}`;
        } else {
          return `${Moment(this.dateFilter.start).format(
            "D MMM YYYY"
          )} - ${Moment(this.dateFilter.end).format("D MMM YYYY")}`;
        }
      } else {
        return null;
      }
    },
  },
  methods: {
    async reload() {
      await this.getSummaryData();

      await this.getCases();
    },
    openCMS(_nodCase) {
      window.open(`${API.cmsNodUrl()}/case-details/${_nodCase._id}`);
    },
    openFile(fileUrl) {
      window.open(fileUrl);
    },
    createNodCms(nod) {
      if (nod) {
        this.nodCases.push(nod);
      }
    },
    addToNOD(_case) {
      this.addToNodData.show = true;

      this.addToNodData.case = _case;
    },
    closeAddToNODModal(e) {
      if (e) {
        const _case = this.cases.find(
          (c) => c._id == this.addToNodData.case._id
        );

        if (_case) {
          _case.nod_case = e;

          this.getSummaryData();
        }
      }

      this.addToNodData.show = false;

      this.addToNodData.case = null;
    },
    async downloadClicked() {
      this.isProcessing = true;
      let query = this.getQuery(true).query;
      query += `&_limit=-1`;
      const { data } = await API.get(`cases?${query}`);

      this.isProcessing = false;

      const dataPoints = data.map((cs, index) => {
        console.log(cs.solveDate);
        let data = {
          District: cs.district ? cs.district.name : "",
          Road: cs.road ? cs.road.name : "",
          Lat: cs.lat,
          Longitude: cs.lng,
          ReportType: cs.reportType,
          TimeStamp: cs.timestamp,
          Status: cs.status,
          Caption: cs.caption,
          Complete: cs.solveDate ? Moment.unix(cs.solveDate).format('YYYY-MM-DDTh:mm:ss A') : ""
        };

        return data;
      });

      let title = {};
      if (dataPoints.length) {
        for (const [key, value] of Object.entries(dataPoints[0])) {
          title[key] = `${key}`;
        }
      }

      dataPoints.unshift(title);

      const ws = XLSX.utils.json_to_sheet(dataPoints, {
        skipHeader: true,
        dateNF: "YYYYMMDD HH:mm:ss",
        origin: "A2",
      });

      const wbb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wbb, ws, `cases`);
      XLSX.writeFile(
        wbb,
        `${Moment(this.dateFilter.start).format("DD-MM")}-${Moment(
          this.dateFilter.end
        ).format("DD-MM")}_${
          this.currentDistrict ? this.currentDistrict.name : "All"
        }.xlsx`
      );
    },
    async handleSelectAllWorkLayers(e) {
      e.stopPropagation();

      this.showAllWorkLayer = !this.showAllWorkLayer;

      const data = this.workScopes;
      const remap = data.map((x) => {
        return {
          ...x,
          show: this.showAllWorkLayer,
        };
      });

      this.workScopes = remap;
      this.workScopeFilter = remap;

      const checking = remap.filter((x) => x.show === false);
      if (checking.length < 9) {
        this.isProcessing = true;

        await this.getSummaryData();
      } else if (checking.length === 9) {
        this.isProcessing = true;

        this.cases = [];

        this.listOfCaseCount = [
          {
            label: "Open Case",
            color: "bg-danger",
            value: 0,
          },
          {
            label: "Closed Case",
            color: "bg-success",
            value: 0,
          },
          {
            label: "Pending",
            color: "bg-warning",
            value: 0,
          },
        ];

        this.isProcessing = false;
      }
    },
    async handleWorkScope(e, id) {
      e.preventDefault();

      const newItem = this.workScopes;
      const index = newItem.findIndex((x) => x.id === id);
      const item = newItem[index];

      let newObj = {
        ...item,
        show: !item.show,
      };

      newItem.splice(index, 1, { ...item, ...newObj });
      this.workScopes = newItem;
      this.workScopeFilter = newItem;

      const checking = newItem.filter((x) => x.show === true);
      if (checking.length > 0) {
        this.isProcessing = true;

        await this.getSummaryData();
      } else if (checking.length === 0) {
        this.isProcessing = true;

        this.cases = [];

        this.listOfCaseCount = [
          {
            label: "Open Case",
            color: "bg-danger",
            value: 0,
          },
          {
            label: "Closed Case",
            color: "bg-success",
            value: 0,
          },
          {
            label: "Pending",
            color: "bg-warning",
            value: 0,
          },
        ];

        this.isProcessing = false;
      }
    },
    closeDateSelected(e) {
      this.showCloseDateSelector = false;

      if (e) {
        this.isProcessing = true;

        API.put(`cases/${this.currentCase._id}`, {
          solveDate: Moment(e).unix(),
          status: "solved",
        })
          .then((retVal) => {
            this.isProcessing = false;

            const caseIndex = this.cases.findIndex(
              (c) => c._id == retVal.data._id
            );

            if (caseIndex > -1) {
              retVal.data.index = this.cases[caseIndex].index;

              this.$set(this.cases, caseIndex, retVal.data);

              this.currentCase = retVal.data;

              this.getCases(true);

              Swal.fire("Case updated", "", "success");
            }
          })
          .catch((err) => {
            this.isProcessing = false;

            console.error(err);
          });
      }
    },
    gotoUpload() {
      this.$router.push({
        name: "upload",
      });
    },
    async saveAfterCaption() {
      if (this.currentCase) {
        this.isProcessing = true;

        const { data } = await API.put(`cases/${this.currentCase._id}`, {
          afterCaption: this.afterCaptionModel,
        });

        this.isProcessing = false;

        if (data) {
          let _case = this.cases.find((c) => c._id == data._id);

          if (_case) {
            _case.afterCaption = data.afterCaption;
          }

          Swal.fire("Repair note saved", "", "success");
        }
      }

      this.isEditingAfterCaption = false;
    },
    cancelEditAfterCaption() {
      this.isEditingAfterCaption = false;

      this.afterCaptionModel = this.currentCase.afterCaption;
    },
    async deleteCase(_case) {
      Swal.fire({
        title: "Delete this case?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          await API.delete(`cases/${_case._id}`);

          this.cases = this.cases.filter((cse) => cse._id != _case._id);

          this.cases = this.cases.map((c, index) => {
            c.index = (this.currentPage - 1) * this.pageLimit + index + 1;

            return c;
          });

          if (this.currentCase && this.currentCase._id == _case._id) {
            this.currentCase = null;
          }

          this.isProcessing = false;

          Swal.fire("Case deleted", "", "success");
        }
      });
    },
    searchByCaseNumber(search) {
      if (this.$route.params.id != search) {
        this.search = search;

        let params = {
          id: search || null,
        };

        this.$router.replace({
          params: params,
        });
      }

      this.changePage(1, true);
    },
    reopenCase(id) {
      Swal.fire({
        html: "Reopen this case?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-primary",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.put(`cases/${id}`, {
            solveDate: null,
            status: "received",
          })
            .then((retVal) => {
              this.isProcessing = false;

              const caseIndex = this.cases.findIndex(
                (c) => c._id == retVal.data._id
              );

              if (caseIndex > -1) {
                retVal.data.index = this.cases[caseIndex].index;

                this.$set(this.cases, caseIndex, retVal.data);

                this.currentCase = retVal.data;

                this.getCases(true);

                Swal.fire("Case re-opened", "", "success");
              }
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error", "error");
            });
        }
      });
    },
    deleteVerification(id) {
      Swal.fire({
        html: "Confirm delete verification?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.delete(`verifications/${id}`)
            .then(() => {
              this.isProcessing = false;

              const caseIndex = this.cases.findIndex(
                (c) => c._id == this.currentCase._id
              );

              if (caseIndex > -1) {
                this.currentCase.verifications =
                  this.currentCase.verifications.filter((v) => v._id != id);
              }

              Swal.fire("", "Verification deleted", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error deleting verification", "error");
            });
        }
      });
    },
    closeAddVerification(response) {
      this.addingVerification = false;

      if (response) {
        const caseIndex = this.cases.findIndex(
          (c) => c._id == this.currentCase._id
        );

        if (caseIndex > -1) {
          if (!this.currentCase.verifications) {
            this.currentCase.verifications = [];
          }

          const verificationIndex = this.currentCase.verifications.findIndex(
            (c) => c._id == response._id
          );

          if (verificationIndex > -1) {
            this.currentCase.verifications[verificationIndex] = response;
          } else {
            this.currentCase.verifications.push(response);
          }

          this.$set(this.cases, caseIndex, this.currentCase);

          Swal.fire("Verification added", "", "success");
        } else {
          Swal.fire("Invalid case ID", "", "error");
        }
      }
    },
    async dateSelected(e) {
      if (typeof e == "object") {
        this.dateFilter = {
          start: Moment(e.start).format("YYYY-MM-DD"),
          end: Moment(e.end).format("YYYY-MM-DD"),
        };
        await this.getSummaryData();
      } else if (typeof e == "boolean" && e == false) {
        this.dateFilter = null;

        await this.getSummaryData();
      }

      this.showDateSelector = null;
    },
    getDistrictName(id) {
      const district = this.allDistricts.find((d) => d._id == id);

      if (id && district) {
        return district.name;
      } else {
        return null;
      }
    },
    async getDistricts() {
      this.isProcessing = true;

      let url = "districtsOnly?_sort=name";

      if (this.userDistricts.length > 0) {
        url = url
          .concat("&_id_in=")
          .concat(
            this.userDistricts.map((district) => district._id).join("&_id_in=")
          );
      }

      return API.get(url)
        .then((retVal) => {
          this.allDistricts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
    },
    async getNodCases() {
      this.isProcessing = true;

      return API.getFromNod("nods")
        .then((retVal) => {
          this.nodCases = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
    },
    async getContractors() {
      this.isProcessing = true;

      let url =
        "contractorsName?name_in=EDGENTA PROPEL BHD&name_in=SELGEM&name_in=SRM SETIA SDN BHD&name_in=SALASAFASA SDN BHD&name_in=WAFI GLOBAL SDN BHD&name_in=DYNAMIC SIGNAL ENTERPRISE&_sort=name";

      return API.get(url)
        .then((retVal) => {
          this.contractors = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    editCase(c) {
      this.editingCase = c;
    },
    async closeEditCase(response) {
      const isNewCase = this.editingCase == "add";

      this.editingCase = null;

      if (response) {
        if (isNewCase) {
          Swal.fire("Case added", "", "success").then(async () => {
            this.isProcessing = true;

            const getCaseNumber = async () => {
              return await API.get(`cases/${response._id}`).then((retVal) => {
                if (retVal.data.caseNumber) {
                  this.searchByCaseNumber(retVal.data.caseNumber);

                  this.isProcessing = true;
                } else {
                  getCaseNumber();
                }
              });
            };

            getCaseNumber();

            this.changePage(1, true);
          });
        } else {
          const caseIndex = this.cases.findIndex((c) => c._id == response._id);

          if (caseIndex > -1) {
            response.index = this.cases[caseIndex].index;

            this.$set(this.cases, caseIndex, response);

            this.currentCase = response;

            Swal.fire("Case edit success", "", "success");
          }
        }
      }
    },
    initMap() {
      return new Promise((resolve) => {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;

        if (!isNaN(this.currentCase.lat) && !isNaN(this.currentCase.lng)) {
          if (!this.map) {
            this.map = new mapboxgl.Map({
              container: "map",
              style: "mapbox://styles/mapbox/dark-v11",
              center: [this.currentCase.lng, this.currentCase.lat],
              zoom: 14,
              interactive: false,
            });

            this.map.addControl(new mapboxgl.NavigationControl());

            this.map.on("load", () => {
              resolve();
            });
          } else {
            this.map.setCenter([this.currentCase.lng, this.currentCase.lat]);
            this.map.setZoom(14);
          }

          this.casePin = this.currentCase;
        }
      });
    },
    deleteImage(type, id, parentId) {
      Swal.fire({
        html: "Confirm delete image?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.delete(`upload/files/${id}`)
            .then(() => {
              this.isProcessing = false;

              if (type == "verification") {
                const caseIndex = this.cases.findIndex(
                  (c) => c._id == this.currentCase._id
                );

                if (caseIndex > -1) {
                  let currentVerification = this.currentCase.verifications.find(
                    (v) => v._id == parentId
                  );

                  if (currentVerification) {
                    currentVerification.media =
                      currentVerification.media.filter((m) => m._id != id);
                  }
                }
              } else if (type == "before") {
                this.currentCase.media = this.currentCase.media.filter(
                  (m) => m._id != id
                );
              } else {
                this.currentCase[`media_${type}`] = this.currentCase[
                  `media_${type}`
                ].filter((f) => f._id != id);
              }

              Swal.fire("", "Image deleted", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error deleting image", "error");
            });

          this.getCases();
        }
      });
    },
    deleteSHFile(type, id, parentId) {
      console.log(this.currentCase);
      Swal.fire({
        html: "Confirm delete File?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.delete(`upload/files/${id}`)
            .then(() => {
              this.isProcessing = false;

              console.log(this.currentCase[`${type}`])
              this.currentCase[`${type}`] = null

              Swal.fire("", "File deleted", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error deleting image", "error");
            });

          this.getCases();
        }
      });
    },
    addImage(type, parentId) {
      let uploader = document.createElement("input");
      uploader.type = "file";
      uploader.accept = "image/*";

      uploader.onchange = (event) => {
        if (event.target.files.length < 1) return;

        let fileModels = {
          ref: type == "verification" ? "verification" : "case",
          refId: parentId ? parentId : this.currentCase._id,
          field: "media",
          files: event.target.files,
        };

        if (type != "verification" && type != "before") {
          fileModels.field = `media_${type}`;
        }

        let endpoint = "upload";

        let fileName = "files";

        let formData = new FormData();

        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            fileModels[key].forEach((file) => {
              formData.append(fileName, file);
            });
          }
        });

        this.isProcessing = true;

        API.postForm(endpoint, formData)
          .then(async (retVal) => {
            if (retVal.data.length > 0) {
              retVal.data.forEach((data) => {
                if (type == "verification") {
                  const caseIndex = this.cases.findIndex(
                    (c) => c._id == this.currentCase._id
                  );

                  if (caseIndex > -1) {
                    let currentVerification =
                      this.currentCase.verifications.find(
                        (v) => v._id == parentId
                      );

                    if (currentVerification) {
                      currentVerification.media.push(data);
                    }
                  }
                } else if (type == "before") {
                  if (this.currentCase.media) {
                    this.currentCase.media.push(data);
                  } else {
                    this.currentCase.media = [data];
                  }
                } else {
                  if (this.currentCase[`media_${type}`]) {
                    this.currentCase[`media_${type}`].push(data);
                  } else {
                    this.currentCase[`media_${type}`] = [data];
                  }
                }
              });
            }

            this.isProcessing = false;
            Swal.fire("", "Image uploaded", "success");
          })
          .catch(() => {
            this.$emit("isLoading", false);

            this.isProcessing = false;
            Swal.fire("", "Image upload failed", "error");
          });
      };

      uploader.click();
    },
    addSHFile(type, parentId) {
      let uploader = document.createElement("input");
      uploader.type = "file";
      uploader.accept = ".pdf";

      uploader.onchange = (event) => {
        if (event.target.files.length < 1) return;

        let fileModels = {
          ref: "case",
          refId: this.currentCase._id,
          field: type,
          files: event.target.files,
        };

        // if (type != "verification" && type != "before") {
        //   fileModels.field = `media_${type}`;
        // }

        let endpoint = "upload";

        let fileName = "files";

        let formData = new FormData();

        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            fileModels[key].forEach((file) => {
              formData.append(fileName, file);
            });
          }
        });

        this.isProcessing = true;

        API.postForm(endpoint, formData)
          .then(async (retVal) => {
            if (retVal.data.length > 0) {
              // retVal.data.forEach((data) => {
                // if (type == "verification") {
                //   const caseIndex = this.cases.findIndex(
                //     (c) => c._id == this.currentCase._id
                //   );

                //   if (caseIndex > -1) {
                //     let currentVerification =
                //       this.currentCase.verifications.find(
                //         (v) => v._id == parentId
                //       );

                //     if (currentVerification) {
                //       currentVerification.media.push(data);
                //     }
                //   }
                // } else if (type == "before") {
                //   if (this.currentCase.media) {
                //     this.currentCase.media.push(data);
                //   } else {
                //     this.currentCase.media = [data];
                //   }
                // } else {
                  // if (this.currentCase[type]) {
                  //   this.currentCase[type].push(data);
                  // } else {
                    this.currentCase[type] = retVal.data[0];
                  // }
                // }
              // });
            }

            this.isProcessing = false;
            Swal.fire("", "Image uploaded", "success");
          })
          .catch(() => {
            this.$emit("isLoading", false);

            this.isProcessing = false;
            Swal.fire("", "Image upload failed", "error");
          });
      };

      uploader.click();
    },
    async changePage(page, force) {
      const x = parseInt(page);

      if (x != this.currentPage || force) {
        if (x > this.totalPage || x < 1) {
          this.inputPage = this.currentPage;

          if (force) {
            await this.getCases();
          }
        } else {
          this.currentPage = x;
          this.inputPage = x;

          await this.getCases();
        }
      }
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    goTo(id) {
      this.currentMedia = null;

      this.showSidebar = false;

      this.currentCase = this.cases.find((cse) => cse._id == id);

      this.afterCaptionModel = this.currentCase
        ? this.currentCase.afterCaption
        : null;

      this.casePin = null;

      const reportBodyContainer = this.$refs.reportBody;

      if (reportBodyContainer) {
        reportBodyContainer.scrollTo(0, 0);
      }

      if (id) {
        this.$nextTick(() => this.initMap());
      }
    },
    getQuery(noLimit) {
      let query =
        "source_ne=socialMedia&reportType=Tender&_sort=timestamp:DESC";

      let queryNoSearch = "";

      if (this.currentDistrict) {
        query += `&district=${this.currentDistrict._id}`;
      } else if (
        this.userRole == "Supervisor" &&
        this.userDistricts.length > 0
      ) {
        query += `&district_in=${this.userDistricts
          .map((ud) => ud._id)
          .join("&district_in=")}`;
      }

      if (this.dateFilter && this.dateFilter.start && this.dateFilter.end) {
        const _dateFilter = {
          start: Moment(this.dateFilter.start).startOf("day").toISOString(),
          end: Moment(this.dateFilter.end).endOf("day").toISOString(),
        };

        query += `&timestamp_gte=${_dateFilter.start}&timestamp_lte=${_dateFilter.end}`;
      }

      if (this.currentPage > 1 && !noLimit) {
        query += `&_start=${(this.currentPage - 1) * this.pageLimit}`;
      }

      // if (this.contractorFilter) {
      //   query += `&contractor=${this.contractorFilter}`;
      // }

      // if(this.timeFilter){

      //   query += this.timeFilter == "AM" ? `&createdTime_null=false&createdTime_gte=23:00:00.000&createdTime_gte=00:00:00.000&createdTime_lte=10:59:59.999` : 
      //     this.timeFilter == "PM" ? '&createdTime_null=false&createdTime_gte=11:00:00.000&createdTime_lte=22:59:59.999' : '';
      // }

      // const unregistered_status = this.workScopes.find(
      //   (x) => x.id == "unregistered"
      // ).show;


      // if (this.search.length === 0 && !unregistered_status) {
      //   const wSFilter = this.workScopes.filter((x) => x.id !== "unregistered");

      //   for (let i = 0; i < wSFilter.length; i++) {
      //     query += wSFilter[i].show
      //       ? `&reportType_in=${wSFilter[i].id}`
      //       : `&reportType_ne=${wSFilter[i].id}`;
      //   }
      // } else if (this.search.length === 0 && unregistered_status) {
      //   const wSFilter = this.workScopes.filter((x) => x.id !== "unregistered");

      //   for (let i = 0; i < wSFilter.length; i++) {
      //     query += `&reportType_ne=${wSFilter[i].id}`;
      //   }
      // }

      queryNoSearch = query;

      if (this.filterByStatus) {
        if (this.filterByStatus == "Open Case") {
          query += `&status_in=received&status_in=inProgress`;
        }

        if (this.filterByStatus == "Closed Case") {
          query += `&status=solved`;
        }

        if (this.filterByStatus == "Pending") {
          query += `&status=pending`;
        }
      } else {
        query += `&status_in=received&status_in=solved&status_in=pending`;
      }

      if (this.search) {
        query += `&caseNumber=${this.search}`;
      }

      const retRes = {
        query: query,
        queryNoSearch: queryNoSearch,
      };

      return retRes;
    },
    async getSummaryData() {
      this.countLoading = true;

      const query = this.getQuery().queryNoSearch;

      let resultTotal = {
        open: 0,
        closed: 0,
        pending: 0,
      };

      const unregistered_status = this.workScopes.find(
        (x) => x.id === "unregistered"
      );

      const wsStatus = this.workScopes
        .filter((x) => x.id !== "unregistered")
        .filter((x) => x.show !== false);

      const resCountOpen = (
        await API.get(
          `cases?${query}` +
            "&_limit=-1&status_in=received&status_in=inProgress"
        )
      ).data;

      let _filterDataOpen = resCountOpen;

      const resCountSolve = (
        await API.get(`cases?${query + "&_limit=-1&status=solved"}`)
      ).data;
      let _filterDataSolve = resCountSolve;

      const resCountPending = (
        await API.get(`cases?${query + "&_limit=-1&status=pending"}`)
      ).data;

      let _filterDataPending = resCountPending;

      if (unregistered_status && wsStatus.length === 0) {
        _filterDataOpen = _filterDataOpen.filter((c) => {
          if (!c.reportType) {
            return c;
          }
        });

        _filterDataSolve = _filterDataSolve.filter((c) => {
          if (!c.reportType) {
            return c;
          }
        });

        _filterDataPending = _filterDataPending.filter((c) => {
          if (!c.reportType) {
            return c;
          }
        });
      }

      resultTotal = {
        open: _filterDataOpen.length,
        closed: _filterDataSolve.length,
        pending: _filterDataPending.length,
      };

      let newData = [
        {
          label: "Open Case",
          color: "bg-danger",
          value: resultTotal.open,
        },
        {
          label: "Closed Case",
          color: "bg-success",
          value: resultTotal.closed,
        },
        {
          label: "Pending",
          color: "bg-warning",
          value: resultTotal.pending,
        },
      ];

      this.listOfCaseCount = newData;

      this.changePage(1, true);
    },
    async handleFilterByStatus(status) {
      if (this.filterByStatus == status) {
        this.filterByStatus = null;
      } else {
        this.filterByStatus = status;

        if (this.search.length > 0) {
          this.searchByCaseNumber("");
        }
      }
      this.changePage(1, true);
    },
    async getCases() {
      this.isProcessing = true;

      const caseListContainer = this.$refs.caseList;

      let query = this.getQuery().query;

      let totalCount = 0;

      // if (this.filterByStatus === "Open Case") {
      //   totalCount = this.listOfCaseCount[0].value;
      // } else if (this.filterByStatus === "Closed Case") {
      //   totalCount = this.listOfCaseCount[1].value;
      // } else if (this.filterByStatus === "Pending") {
      //   totalCount = this.listOfCaseCount[2].value;
      // } else {
      //   totalCount =
      //     this.listOfCaseCount[0].value +
      //     this.listOfCaseCount[1].value +
      //     this.listOfCaseCount[2].value;
      // }

      // this.casesCount = totalCount;

      this.totalPage = Math.ceil(totalCount / this.pageLimit);

      try {
        if (this.search) {
          query = `caseNumber=${this.search}`;
        }

        const { data } = await API.get(`cases?${query}`);

        let _filteredData = data;

        const unregistered_status = this.workScopes.find(
          (x) => x.id === "unregistered"
        );

        const wsStatus = this.workScopes
          .filter((x) => x.id !== "unregistered")
          .filter((x) => x.show !== false);

        if (this.verifiedFilter) {
          _filteredData = _filteredData.filter(
            (d) => d.verifications && d.verifications.length > 0
          );

          if (_filteredData.length === 0) {
            this.listOfCaseCount = [
              {
                label: "Open Case",
                color: "bg-danger",
                value: 0,
              },
              {
                label: "Closed Case",
                color: "bg-success",
                value: 0,
              },
              {
                label: "Pending",
                color: "bg-warning",
                value: 0,
              },
            ];
          }
        }

        if (unregistered_status.show && wsStatus.length === 0) {
          _filteredData = _filteredData.filter((c) => {
            if (!c.reportType) {
              return c;
            }
          });
        }

        this.cases = _filteredData.map((c, index) => {
          c.index = (this.currentPage - 1) * this.pageLimit + index + 1;

          return c;
        });

        if (caseListContainer) {
          caseListContainer.scrollTo(0, 0);
        }

        if (this.cases.length > 0) {
          this.goTo(this.cases[0]._id);
        } else {
          if (this.map) {
            this.map.remove();

            this.map = null;
          }

          this.goTo(null);
        }
      } catch (error) {
        console.error(error);
      }

      this.countLoading = false;

      this.isProcessing = false;
    },
  },
  async mounted() {
    let _user = localStorage.getItem("user");

    if (_user) {
      _user = JSON.parse(_user);

      if (_user.districts && _user.districts.length > 0) {
        this.userDistricts = _user.districts.map((district) => {
          return {
            _id: district._id,
            name: district.name,
          };
        });
      }

      this.userRole = _user.role.name;
    }

    if (this.$route.params.id) {
      this.search = this.$route.params.id;
    }



    // await this.getNodCases();

    await this.getDistricts();
    await this.getCases()

    // await this.getContractors();

    // this.isProcessing = true;

    // await this.getSummaryData();
  },
};
</script>